import { Button, Flex, Form, Input, Select, SelectProps, Spin } from "antd";
import { useMutation } from "react-query";
import { mdlReservationSendMailRequest } from "../../models/service-models/reservation/ReservationSendMailRequest";
import { ReservationService } from "../../services/ReservationService";
import { mdlReservation } from "../../models/domain/Reservation";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { ObjectHelper } from "../../utils/ObjectHelper";
import { useTranslation } from "react-i18next";
import { mdlMailObject } from "../../models/domain/value-objects/MailObject";
import { RuleObject } from "antd/es/form";


export type ReservationMailProps = {
    callback?: Function;
    reservations?: Array<mdlReservation>;
}

const ReservationMail = (props: ReservationMailProps) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const bccValues: SelectProps['options'] = [];

    useEffect(() => {

    }, [props])

    const { mutateAsync: sendMail, isLoading, data } = useMutation(
        (data: mdlReservationSendMailRequest) => ReservationService.SendMail(data),
        {
            onMutate(variables) {
                console.log(variables);
                variables.reservations = props.reservations!;
            },
            onError: error => {
                console.log(error);
            },
            onSuccess(data, variables, context) {
                if (data.header && data.header.success && data.body && data.body.succeed) {
                    form.resetFields();
                    props.callback && props.callback();
                } else {
                    toast.error(ObjectHelper.getErrorMessage(data.header.messages));
                }
            },
        }
    );

    const validateEmail = (_: RuleObject, value: string[]) => {
        if (value != null && value.length > 0) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const invalidEmails = value.filter((email) => !emailRegex.test(email));
            if (invalidEmails.length > 0) {
                return Promise.reject(new Error(`${invalidEmails.join(', ')} ${t("common.isNotAValidMailAddress")}`));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    return (
        <Spin spinning={isLoading}>
            <Form
                form={form}
                name="send-reservation-mail-form"
                layout="vertical"
                onFinish={async (values) => await sendMail(values)}
                autoComplete="off"
            >
                <Form.Item<mdlReservationSendMailRequest>
                    label={t("resMail.to")}
                    name={['mail', 'to']}
                    rules={[
                        { required: true, message: t("common.required") },
                        {
                            validator: validateEmail,
                        },
                    ]}
                >
                    <Select
                        mode="tags"
                        placeholder={t("resMail.toPlaceholder")}
                        options={[]}
                    />
                </Form.Item>

                <Form.Item<mdlReservationSendMailRequest>
                    label={t("resMail.cc")}
                    name={['mail', 'cc']}
                    rules={[
                        {
                            validator: validateEmail,
                        },
                    ]}
                >
                    <Select
                        mode="tags"
                        placeholder={t("resMail.ccPlaceholder")}
                        options={[]}
                    />
                </Form.Item>

                <Form.Item<mdlReservationSendMailRequest>
                    label={t("resMail.bcc")}
                    name={['mail', 'bcc']}
                    rules={[
                        {
                            validator: validateEmail,
                        },
                    ]}
                >
                    <Select
                        mode="tags"
                        placeholder={t("resMail.bccPlaceholder")}
                        options={[]}
                    />
                </Form.Item>

                <Form.Item<mdlReservationSendMailRequest>
                    label={t("resMail.subject")}
                    name={['mail', 'subject']}
                    rules={[
                        { required: true, message: t("common.required") }
                    ]}

                >
                    <Input placeholder={t("resMail.subjectPlaceholder")} />
                </Form.Item>

                <Form.Item<mdlReservationSendMailRequest>
                    label={t("resMail.content")}
                    name={['mail', 'content']}
                    rules={[
                        { required: true, message: t("common.required") }
                    ]}
                >
                    <Input.TextArea rows={5} placeholder={t("resMail.contentPlaceholder")} />
                </Form.Item>


                <Form.Item>
                    <Flex align={"center"} justify="flex-end">
                        <Button type="primary" htmlType="submit">{t("resMail.send")}</Button>
                    </Flex>

                </Form.Item>
            </Form>
        </Spin>

    )
}

export default ReservationMail;